import { render } from "./OnlineOrderHistoryPage.vue?vue&type=template&id=6adfdeae"
import script from "./OnlineOrderHistoryPage.vue?vue&type=script&lang=js"
export * from "./OnlineOrderHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__